export default "__VITE_ASSET__Bv9lkZV___"